import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bi-tmpl-detail__right__cmpt" }
const _hoisted_2 = {
  key: 0,
  class: "bi-tmpl-detail__right__cmpt__tips"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { style: {
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0'
            } }
const _hoisted_5 = { style: {"transform":"scale(0.36)","width":"1163px","height":"1665px","transform-origin":"0px 0px","overflow":"hidden"} }
const _hoisted_6 = { class: "bi-tmpl-detail__right__cmpt__radioBox" }

import PcModuleCover, {
  posDefaultConfig
} from '../bi-pc-module/pc-module-cover';

import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';


export default /*#__PURE__*/_defineComponent({
  __name: 'bi-tmpl-detail-102',
  setup(__props) {

const getAttrs = (templateName: string) => ({
  projectName: '关于阿莫西林产品在全国区域的患者诊疗现状调研项目数据报告',
  time: '2024-01-31',
  mainPageEnterpriseName: '项目方：盛安制药有限公司',
  orderNumber: 'GSD1234567890123456',
  titlePosition: JSON.parse(posDefaultConfig[templateName].titlePosition),
  settleTimePosition: JSON.parse(
    posDefaultConfig[templateName].settleTimePosition
  ),
  aspNamePosition: JSON.parse(posDefaultConfig[templateName].aspNamePosition),
  orderNumberPostion: JSON.parse(
    posDefaultConfig[templateName].orderNumberPostion
  )
});

const TYPE_MAPPING = {
  1: {
    value: 'pc-module-cover-1',
    moduleType: 'pc-module-cover-1'
  },
  2: {
    value: 'pc-module-cover-2',
    moduleType: 'pc-module-cover-2'
  },
  3: {
    value: 'pc-module-cover-3',
    moduleType: 'pc-module-cover-3'
  },
  4: {
    value: 'pc-module-cover-4',
    moduleType: 'pc-module-cover-4'
  },
  5: {
    value: 'pc-module-cover-5',
    moduleType: 'pc-module-cover-5'
  },
  6: {
    value: 'pc-module-cover-6',
    moduleType: 'pc-module-cover-6'
  },
  7: {
    value: 'pc-module-cover-7',
    moduleType: 'pc-module-cover-7'
  },
  8: {
    value: 'pc-module-cover-8',
    moduleType: 'pc-module-cover-8'
  },
  9: {
    value: 'pc-module-cover-9',
    moduleType: 'pc-module-cover-9'
  },
  10: {
    value: 'pc-module-cover-10',
    moduleType: 'pc-module-cover-10'
  }
};

const cmpName = name => {
  return PcModuleCover.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_unref(curItem).tips)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(curItem).tips), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Carousel), {
      ref: "carouselRef",
      itemHeight: 675,
      itemWidth: 420 + 56
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TYPE_MAPPING, (item, index) => {
          return _createElementVNode("div", { key: index }, [
            _createElementVNode("div", {
              class: "xrk-card",
              onClick: ($event: any) => (_unref(onChange)(item.value)),
              style: {"width":"420px","height":"600px"}
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(cmpName(item.moduleType)), _mergeProps({ ref_for: true }, getAttrs(item.moduleType)), null, 16))
                ])
              ])
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(BaseRadio), {
                value: item.value,
                "model-value": _unref(curItem).value,
                onClick: ($event: any) => (_unref(onChange)(item.value))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(), 1)
                ]),
                _: 2
              }, 1032, ["value", "model-value", "onClick"])
            ])
          ])
        }), 64))
      ]),
      _: 1
    }, 512)
  ]))
}
}

})